import type { Transaction } from "@/types/payments";

/**
 * A 0,00 bank transaction moved no money: it is never matched and never booked (FIN-804,
 * learnings/027). Exactly zero only — 0,01 is an ordinary transaction.
 */
export function isZeroAmountTransaction(transaction: Pick<Transaction, "amount">): boolean {
  return transaction.amount === 0;
}
